import * as React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { userStore } from '../../store/UserStore';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CreateSubAccount from 'pages/profile/components/create-sub-account';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import { toast } from 'react-toastify';

interface PropsType {
  mainTitle: string;
  subTitle: string;
  isShowSub?: boolean;
  isShowAccount?: boolean;
}

const PageHeader: React.FC<PropsType> = ({
  mainTitle,
  subTitle,
  isShowSub = true,
  isShowAccount = true,
}) => {
  const [
    setSelectedAccount,
    selectedAccount,
    customer,
    customerId,
    customers,
    setCustomerId,
    setCustomer,
  ] = userStore((state: any) => [
    state.setSelectedAccount,
    state.selectedAccount,
    state.customer,
    state.customerId,
    state.customers,
    state.setCustomerId,
    state.setCustomer,
  ]);
  const history = useHistory();
  const [isShow, setIsShow] = React.useState(false);
  const [isSubOptionDisplayed, setIsSubOptionDisplayed] = React.useState(false);
  const onChangeAccount = (key: any, event: any) => {
    if (event.target.name === 'create_sub_account') {
      setIsShow(true);
    } else {
      let account = customer?.accounts.find(
        (item: any) => item.accountId === event.target.name
      );
      if (account) {
        setSelectedAccount(account);
      }
    }
  };

  useEffect(() => {
    if (customer.customerCategory === 'REGISTERED' && customer.companyGSTIN)
      getGstn(customer.customerId, customer?.kyc?.pan?.value);
  }, []);

  const getGstn = async (customerId, panNumber) => {
    try {
      const data = {
        customerId: customerId,
        pan: panNumber,
      };
      const res: any = await CustomerOnboardingHttp.getGstns(data);
      if (res.status === 200 && res.data.data) {
        if (customer.customerType !== 'IND') {
          if (res.data.data.gstins && res.data.data.gstins.length > 0) {
            const response = res.data.data.gstins.filter(
              (item) => item?.hasSubAccount === false
            );
            if (response.length > 0) setIsSubOptionDisplayed(true);
          }
        }
      } else {
        setIsSubOptionDisplayed(false);
        console.error('Something went wrong');
      }
    } catch (e: any) {
      setIsSubOptionDisplayed(false);
      console.error('Something went wrong');
    }
  };

  // useEffect((): any => {
  //   if (customer.accounts && customer.accounts.length > 0) {
  //     let account = customer.accounts.filter(
  //       (item: any) => item.isPrimary === true
  //     );
  //     if (account.length > 0) {
  //       setSelectedAccount(account[0]);
  //     }
  //   }
  // }, [customer.accounts]);

  const handleAccountCanvas = (isShow) => {
    setIsShow(isShow);
  };

  return (
    <>
      <CreateSubAccount handleModal={handleAccountCanvas} isShow={isShow} />
      <div className='column-style main-title d-flex justify-content-lg-between justify-content-md-between justify-content-sm-start  mb-3'>
        {/* <div className='column-style main-title d-flex justify-content-lg-between justify-content-md-between justify-content-sm-start align-items-end mb-3'> */}
        <div className=''>
          {isShowSub ? (
            <div className='dash__f-18'>
              Hi, {customer?.displayName}
              {/* <Dropdown onSelect={onChangeAccount} className='d-inline'>
                <Dropdown.Toggle
                  variant='eb-btn'
                  id='dropdown-basic'
                  size='lg'
                  childBsPrefix='dash-btn'
                >
                  {customer?.displayName}
                </Dropdown.Toggle>
                <Dropdown.Menu bsPrefix='dash-dropdown-menu'>
                  {customers?.map((cust: any, index: number) => {
                    return (
                      <Dropdown.Item
                        key={index}
                        name={cust.customerId}
                        onClick={() => {
                          setCustomerId(cust.customerId);
                          setCustomer(cust);
                        }}
                        bsPrefix='dash-dropdown-item'
                      >
                        {cust.displayName}
                      </Dropdown.Item>
                    );
                  })}

                  <Dropdown.Divider></Dropdown.Divider>
                  <Dropdown.Item
                    key={'dash__1'}
                    name={'Create Account'}
                    onClick={() => history.push('/customers')}
                    bsPrefix='dash-dropdown-item'
                  >
                    Create Account
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
            </div>
          ) : (
            ''
          )}
          <h5>{subTitle}</h5>
        </div>
        {/* Escrow Account Number */}
        {/* {isShowAccount && (
          <div className='d-flex flex-column align-items-end justify-content-end'>
            <div className='h5'>Account Number</div>
            <div className='h6 text-muted'>EBACX12345</div>
          </div>
        )} */}
        {/* {isShowSub && customer?.accounts?.length > 0 ? (
          <div className='d-flex flex-column  justify-content-end'>
            <Dropdown onSelect={onChangeAccount}>
              <Dropdown.Toggle
                variant='eb-btn'
                id='dropdown-basic'
                disabled={
                  customer?.customerCategory !== 'REGISTERED' ||
                  !selectedAccount?.kyc?.gstin?.value
                }
              >
                {customer?.customerCategory === 'REGISTERED'
                  ? selectedAccount?.kyc?.gstin?.value
                    ? selectedAccount?.kyc?.gstin?.value
                    : selectedAccount?.accountId
                  : `${selectedAccount.accountId} - ${selectedAccount.displayName}`}
              </Dropdown.Toggle>
              <Dropdown.Menu className='acc-dropdown'>
                {customer?.accounts?.map((account: any, index: number) => {
                  return (
                    <Dropdown.Item key={index}>
                      {customer.customerCategory === 'REGISTERED'
                        ? account?.kyc?.gstin?.value
                          ? account?.kyc?.gstin?.value
                          : account?.accountId
                        : account.accountId}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        ) : (
          ''
        )} */}
      </div>
      {/* <div className='main-title justify-content-between align-items-end mb-3 d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none'>
        <h1>{mainTitle}</h1>
        <h5>{subTitle}</h5>
      </div> */}
    </>
  );
};

export default React.memo(PageHeader);
